import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import FullscreenBtn from './FullscreenBtn';

export class Header extends React.Component {
	render() {
		return (
			<header>
		    	{this.props.section.section !== 'menu' && <div id="header-title" style={{backgroundImage: `url(./images/sections/${this.props.section.section}/title/title.svg)`}}></div>}
		    	{this.props.section.section !== 'menu' && <NavLink to="/" activeClassName="is-active" exact={true}><div id="home-btn" title="Home button" className="header-btn"></div></NavLink>}
		    	<a id="help-btn" href="documents/help.pdf" target="_blank" title="Help button" className={"header-btn" + (this.props.ios.ios ? ' ios' : '')}></a>
	    		{!this.props.ios.ios && <FullscreenBtn />}
		  	</header>
	  	);
	}
};

const mapStateToProps = function(state) {
	return {
		ios: state.ios,
		section: state.section
	}
}

export default connect(mapStateToProps, undefined)(Header);



// WEBPACK FOOTER //
// ./src/components/global/header/Header.js